import FactorialI18n from 'factorial-i18n'

import i18n from 'modules/core/lib/i18n'
import companies from 'modules/core/store/collections/companies'
import legalEntities from 'modules/core/store/collections/legalEntities'
import type { Company } from 'modules/core/store/models/Company'

export const getLegalEntityCurrency = (legal_entity_id: number) => {
  return legalEntities.find({
    id: legal_entity_id,
  })?.attributes.currency
}

const getCompanyCurrency = (company: Company | null) => {
  if (!company) {
    company = companies.selected
  }

  return company?.attributes.currency
}

export function getCurrencySymbol(): string {
  return companies.selected?.attributes.currency_symbol
}

export default function formatCurrency(
  quantityInCents: number,
  overrideLocale?: string,
  company: Company | null = null,
  legalEntityId?: number
): string {
  const formatter = overrideLocale ? getCustomI18n(overrideLocale) : i18n
  const currency = legalEntityId
    ? getLegalEntityCurrency(legalEntityId)
    : getCompanyCurrency(company)

  return formatter.formatNumber(quantityInCents / 100, 'currency', currency)
}

const getCustomI18n = (locale: string) => {
  // TODO: [ts-migration] Should this use lib/i18n instead of factorial-i18n?
  const customi18n = new FactorialI18n()
  customi18n.setLocale(locale)
  customi18n.setLocaleFallback('en')

  return customi18n
}
